import { CircularProgress, type Theme } from '@mui/material'
import type { VariantType } from 'notistack'
import type { ReactNode } from 'react'

declare module 'notistack' {
  interface VariantOverrides {
    // hyphen rather than . as this becomes a CSS class
    loading: true
  }
}

const iconSelector = '#notistack-snackbar > svg'

// Global styles for notistack snackbars. notistack is not an MUI component, so
// it can't be themed via theme.components — it ships stable class names that we
// target through MUI's <GlobalStyles>.
export const snackbarStyles = (theme: Theme) => ({
  '.notistack-Snackbar': {
    '.notistack-MuiContent': {
      boxShadow: theme.customShadows.xs,
      borderRadius: theme.shape['radius-lg'],
      borderStyle: 'solid',
      borderWidth: theme.strokeWidth.default,
      borderColor: theme.palette.border.subtle,
      backgroundColor: theme.palette.bg.surface.elevated,
      color: theme.palette.text.default,
      padding: theme.spacing(2, 4),
      ...theme.typography['body-medium'],
      [`& ${iconSelector}`]: {
        fontSize: 18,
        // Override inline style
        marginRight: `${theme.spacing(2.5)} !important`,
        alignSelf: 'flex-start',
        paddingTop: theme.spacing(1),
      },
    },
    [`.notistack-MuiContent-success ${iconSelector}`]: {
      color: theme.palette.fg.success.default,
    },
    [`.notistack-MuiContent-info ${iconSelector}`]: {
      color: theme.palette.fg.info.default,
    },
    [`.notistack-MuiContent-warning ${iconSelector}`]: {
      color: theme.palette.fg.warning.default,
    },
    [`.notistack-MuiContent-error ${iconSelector}`]: {
      color: theme.palette.fg.danger.default,
    },
    '.notistack-MuiContent-loading': {
      // Loading spinner is a span with an svg inside
      '& .MuiCircularProgress-root': {
        color: theme.palette.fg.default,
        marginRight: theme.spacing(2.5),
        '& svg': {
          // Override inline style and !important above
          marginRight: '0 !important',
        },
      },
    },
  },
})

// TODO - updated icons
export const snackbarIconVariants: Partial<Record<VariantType, ReactNode>> = {
  loading: <CircularProgress size={18} />,
}
